<template>
    <div class="productdetail-container">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
        </div>
        <el-tabs type="border-card" tab-position="top" @tab-click="handleClick" v-model="tabSel">
            <el-tab-pane label="产品管理" name="tab0">
                <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
                    <el-button size="small" type="danger" @click="addProduct(proDetail)">
                        {{proId == 0 ? '下一步' : '保 存'}}
                    </el-button>
                </div>
                <el-form v-if="proId==0" label-width="120px">
                    <el-form-item label="">
                        <el-alert title="新建商品时 从下拉框选择要导入的商品会从erp带入69码、商品编码、商品名称、规格型号、单位、保持期天数、建议价格、是否上架信息，请核实完再保存"
                                  type="success" :closable="false">
                        </el-alert>
                    </el-form-item>
                    <el-form-item label="选择导入商品">
                        <el-select v-model="erpProId" clearable filterable placeholder="选择从erp中导入商品"
                                   @change="selectProductChanged">
                            <el-option
                                    v-for="item in erpProductList"
                                    :key="item.cguid"
                                    :label="item.cname"
                                    :value="item.cguid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-form :model="proDetail" label-width="120px">
                    <el-form-item label="商品名称" :required="true">
                        <el-input v-model="proDetail.proName" placeholder="匹配商城产品大标题（包含长期订购）"></el-input>
                    </el-form-item>
                    <el-form-item label="商品别名">
                        <el-input v-model="proDetail.proOtherName" placeholder="匹配商城产品小标题（包含长期订购）"></el-input>
                    </el-form-item>
                    <el-form-item label="商品名称缩写" :required="true">
                        <el-input v-model="proDetail.proNameSx" placeholder="匹配ERP2.0单品销售报表产品名称"></el-input>
                    </el-form-item>
                    <el-form-item label="商品编号" :required="true">
                        <el-input v-model="proDetail.proCode" placeholder="商品编号"></el-input>
                    </el-form-item>

                    <el-form-item label="条形码" :required="true">
                        <el-input v-model="proDetail.barCode" placeholder="条形码 配送的商品请按erp3.0中来填写，不配送商品可自行填写不与配送商品重复即可"
                                  class="is-required"></el-input>
                        <!--<el-button size="small" v-show="proDetail.transportType==3" type="primary" @click="gen(proDetail)">生成条形码</el-button>-->
                    </el-form-item>
                    <el-form-item label="商品标题" :required="true">
                        <el-input v-model="proDetail.proTitle" placeholder="匹配订单详情页展示名称"></el-input>
                    </el-form-item>
                    <el-form-item label="商品名称摘要" :required="true">
                        <el-input v-model="proDetail.proSummary" placeholder="商品名称"></el-input>
                    </el-form-item>
                    <el-form-item label="产品类型" :required="true">
                        <el-select v-model="proDetail.proTypeId" clearable placeholder="产品类型">
                            <el-option
                                    v-for="item in productTypes"
                                    :key="item.proTypeId"
                                    :label="item.proType"
                                    :value="item.proTypeId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售类型" :required="true">
                        <el-select v-model="proDetail.soldType" clearable filterable placeholder="销售类型">
                            <el-option
                                    v-for="item in soldTypes"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="运输方式" :required="true">
                        <el-select v-model="proDetail.transportType" @change="selectTransportType" clearable filterable
                                   placeholder="运输方式">
                            <el-option
                                    v-for="item in transportTypes"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品类目" :required="true">
                        <el-select v-model="proDetail.productCategoryId" clearable filterable placeholder="产品类目">
                            <el-option
                                    v-for="item in productCategoryIds"
                                    :key="item.key"
                                    :label="item.value"
                                    :disabled="item.disabled"
                                    :value="item.key">
                            </el-option>
                        </el-select>
                        <span>按照产品实际归属品类选择</span>
                    </el-form-item>

                    <el-form-item label="是否自营" :required="true" v-show="false">
                        <el-select v-model="proDetail.selfMadeType" clearable filterable placeholder="是否自营">
                            <el-option
                                    v-for="item in selfMadeTypes"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="规格型号" :required="true">
                        <el-input v-model="proDetail.proSpec" placeholder="输入规格型号..."></el-input>
                    </el-form-item>
                    <el-form-item label="单位">
                        <el-input v-model="proDetail.proDw" placeholder="盒，件，箱等..."></el-input>
                    </el-form-item>
                    <!--            <el-form-item label="占位">-->
                    <!--                <el-input v-model="proDetail.proSize" placeholder="【注意：135克酸奶占位为6,80克酸奶占位为4，其他请咨询ERP开发人员】"></el-input>-->
                    <!--            </el-form-item>-->
                    <el-form-item label="单次最大购买量" :required="true">
                        <el-input-number v-model="proDetail.limitBuyCount" placeholder="输入最大购买量..."></el-input-number>
                    </el-form-item>
                    <el-form-item label="每日最大购买量" :required="true">
                        <el-input-number v-model="proDetail.limitBuyCountDaily"
                                         placeholder="输入每日最大购买量..."></el-input-number>
                    </el-form-item>
                    <el-form-item label="前台售价" :required="true">
                        <el-input-number v-model="proDetail.proPrice" placeholder="前台售价"></el-input-number>
                        <span>用户购买价格，会员价也是通过这个价格打折计算的</span>
                    </el-form-item>
                    <el-form-item label="单品原价" :required="true">
                        <el-input-number v-model="proDetail.proPrice1" placeholder="单品原价"></el-input-number>
                    </el-form-item>
                    <!--            <el-form-item label="其他价格2">-->
                    <!--                <el-input v-model="proDetail.proPrice2" placeholder="其他价格2"></el-input>-->
                    <!--            </el-form-item>-->
                    <el-form-item label="保质期(天)">
                        <el-input v-model="proDetail.period" placeholder="保质期(天)"></el-input>
                    </el-form-item>
                    <el-form-item label="产品简述">
                        <el-input v-model="proDetail.memo" placeholder="产品简述"></el-input>
                    </el-form-item>
                    <el-form-item label="配料">
                        <el-input v-model="proDetail.memoPeiliao" placeholder="配料"></el-input>
                    </el-form-item>
                    <el-form-item label="储藏条件">
                        <el-input v-model="proDetail.memoChucang" placeholder="储藏条件"></el-input>
                    </el-form-item>
                    <el-form-item label="可用券" :required="true">
                        <el-select v-model="proDetail.useCoupon"  placeholder="可用券">
                            <el-option v-for="item in useCashList"
                                       :key="item.value"
                                       :label="item.name"
                                       :value="item.value"
                            ></el-option>
                        </el-select>
                        <el-label>该商品能不能用券，不会限制到整单上</el-label>
                    </el-form-item>
                    <el-form-item label="下架日期">
                        <el-date-picker
                                v-model=proDetail.downDate
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="不下架不要填写">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="是否上架" :required="true">
                        <el-select v-model="proDetail.proState" clearable placeholder="是否上架">
                            <el-option
                                    v-for="item in proStates"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="列表模版">
                        <el-input v-model="proDetail.listTemplateFile" placeholder="列表模版" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="详情模版">
                        <el-input v-model="proDetail.detailTemplateFile" placeholder="详情模版"></el-input>
                    </el-form-item>
                    <el-form-item label="是否列表显示">
                        <el-select v-model="proDetail.showState" clearable placeholder="是否列表显示">
                            <el-option
                                    v-for="item in showStates"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input-number v-model="proDetail.sort" :min="0" :step="1" :max="9990"
                                         placeholder="排序"></el-input-number>
                    </el-form-item>
                    <!--<el-form-item label="品牌">-->
                    <!--<el-select v-model="proDetail.brandId" clearable filterable placeholder="品牌">-->
                    <!--<el-option-->
                    <!--v-for="item in brandList"-->
                    <!--:key="item.brand_id"-->
                    <!--:label="item.brand_wording"-->
                    <!--:value="item.brand_id">-->
                    <!--</el-option>-->
                    <!--</el-select>-->

                    <!--</el-form-item>-->
                     <el-form-item label="售卖仓库">
                        <el-select 
                            v-model="proDetail.storeCodes" 
                            multiple 
                            clearable 
                            filterable
                            placeholder="售卖仓库"
                            @change="handleStoreCodesChange">
                            <el-option
                                v-for="item in storeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="小商店类目">
                        <el-cascader
                                v-model="proDetail.thirdCatId"
                                :props="{value:'id',label:'name'}"
                                :options="categoryList"
                                @change="handleChange">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="danger" size="small" @click="addProduct(proDetail)" class="header-btn">
                            {{proId == 0 ? '下一步' : '保 存'}}
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="图片管理" v-if="proId!=0" name="tab1">
                <pictureM></pictureM>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {
        getProductsList4Erp,
        getProductList,
        getProductType,
        delProduct,
        getProduct,
        addProduct,
        get_brand_list,
        getMallItemConfigUseStatusList,
        getWxStoreSearch,
        getSkuCatList
    } from '@/api/api'
    import pictureM from '@/components/picture'

    export default{
        data(){
            return {
                proId: this.$route.query.proId,
                proDetail: {},
                tabSel: 'tab0',
                erpProductList: [],
                erpProId: '',
                secondCatId: '',
                firstCatId: '',
                formInline: {
                    platformId: 4
                },
                proStates: [{
                    key: 0,
                    value: "未上架"
                }, {
                    key: 1,
                    value: "已上架"
                }, {
                    key: 9,
                    value: "已下架"
                }],
                showStates: [{
                    key: 0,
                    value: "不显示"
                }, {
                    key: 1,
                    value: "显示"
                }],
                soldTypes: [{
                    key: "零售",
                    value: "零售"
                }, {
                    key: "包月",
                    value: "包月"
                }, {
                    key: "线下销售",
                    value: "线下销售"
                }],
                productCategoryIds: [
                    {key: "1", value: "低温乳品", disabled: true},
                    {key: "39", value: "　希腊酸奶-80g"},
                    {key: "16", value: "　希腊果味小规格"},
                    {key: "17", value: "　希腊酸奶-N300"},
                    {key: "18", value: "　希腊酸奶-500g"},
                    {key: "181", value: "　希腊MaxPro"},
                    {key: "182", value: "　希腊大师装"},
                    {key: "101", value: "　希腊酸奶-全脂"},
                    {key: "102", value: "　希腊酸奶-零脂"},
                    {key: "105", value: "　乳糖没了"},
                    {key: "24", value: "　饮用型酸奶-你好轻松"},
                    {key: "13", value: "　饮用型酸奶-纤酵"},
                    {key: "25", value: "　零酪"},
                    {key: "41", value: "　新鲜乳酪"},
                    {key: "43", value: "　纯净系列"},
                    {key: "430", value: "　0系列"},
                    {key: "103", value: "　纯净翻乐碗"},
                    {key: "104", value: "　纯净零蔗糖"},
                    {key: "44", value: "　爱心奶酪"},
                    {key: "45", value: "　宝宝奶酪"},
                    {key: "46", value: "　铂金奶酪"},
                    {key: "38", value: "　其他"},
                    {key: "106", value: "　超纯"},
                    {key: "107", value: "　布丁"},
                    {key: "108", value: "　宝宝酸奶-低温"},
                    {key: "109", value: "　优格沙拉"},
                   
                    {key: "113", value: "　超满足"},
                    {key: "114", value: "　干噎"},
                    {key: "110", value: "　希腊酸奶LITE 400g"},
                    {key: "111", value: "　希腊酸奶LITE 70g"},
                    {key: "112", value: "　希腊酸奶LITE 112g"},
                    {key: "115", value: "　希腊酸奶LITE 720g"},


                    {key: "26", value: "常温乳品", disabled: true},
                    {key: "21", value: "　拉菲牛乳"},
                    {key: "2101", value: "　特种奶"},
                    {key: "2102", value: "　特种奶Mini"},
                    {key: "2103", value: "　高端特种奶"},
                    {key: "2104", value: "　高端特种奶Mini"},
                    {key: "2105", value: "　平价特种奶"},
                    {key: "2106", value: "　平价特种奶Mini"},
                    {key: "40", value: "　益生菌"},
                    {key: "42", value: "　萃乳"},
                    {key: "261", value: "　益牛乳"},
                   
                    {key: "262", value: "　宝宝米酪"},
                    {key: "263", value: "　宝宝酸奶"},
                    {key: "264", value: "　宝宝奶酪"},
                    {key: "265", value: "　花色奶"},
                    {key: "266", value: "　水牛酪乳"},
                    {key: "267", value: "　mini水牛奶"},
                    {key: "268", value: "　米酪"},
                    {key: "269", value: "　水牛宝贝"},
                    {key: "270", value: "　轻盈LITE"},
                    {key: "271", value: "　果泥奶酪"},
                    {key: "272", value: "　蔬果酸奶"},
                    



                    {key: "3", value: "烘焙", disabled: true},
                    {key: "19", value: "　烘焙-低温"},
                    {key: "20", value: "　烘焙-常温"},
                    {key: "4", value: "控热", disabled: true},
                    {key: "27", value: "　控热常温"},
                    {key: "28", value: "　控热低温"},
                    {key: "5", value: "宝藏", disabled: true},
                    {key: "30", value: "　燕麦片常温"},
                    {key: "15", value: "　燕麦粥常温"},
                    {key: "31", value: "　燕麦粥低温"},
                    {key: "29", value: "　燕麦片低温"},
                    {key: "8", value: "咖啡"},
                    {key: "32", value: "非实物产品", disabled: true},
                    {key: "9", value: "　优惠券"},
                    {key: "10", value: "　储值卡"},
                    {key: "33", value: "　电子卡包"},
                    {key: "12", value: "其他", disabled: true},
                    {key: "11", value: "　随箱辅料"},
                    {key: "34", value: "　赠品"},
                    {key: "35", value: "　券卡"},
                    {key: "36", value: "　储值卡"},
                    {key: "37", value: "　实物卡包"},
                    {key: "7", value: "　零食"},
                ],
                transportTypes: [{
                    key: 1,
                    value: "冷链运输"
                }, {
                    key: 2,
                    value: "普通快递"
                }, {
                    key: 3,
                    value: "线上兑换-不配送"
                }],
                selfMadeTypes: [{
                    key: 1,
                    value: "自营"
                }, {
                    key: 2,
                    value: "非自营"
                }],
                brandList: [],
                tempThirdCatList: [],
                secondtCatList: [],
                tempSecondCatList: [],
                firstCatList: [],
                useCashList:[],
                storeList:[],
                categoryList: []
            }
        },
        components: {
            pictureM
        },
        computed: {
            productTypes: function () {
                return this.$store.getters.getProductType
            }
        },
        mounted(){
            this.getConfigUseStatusList()
            this.$store.dispatch('initProductType')
            this.getCategoryList();
            this.getStoreList('')
            
        },
        methods: {
            initProDataDetail(){
                getProduct({proId: this.proId}).then(res => {
                    console.log(res)
                    this.proDetail = res.data.value
                    if (this.proDetail.storeCodes && typeof this.proDetail.storeCodes === 'string') {
                        this.proDetail.storeCodes = this.proDetail.storeCodes.split(',');
                    }
                })
            },
            getConfigUseStatusList(){
                getMallItemConfigUseStatusList().then((res) => {
                    this.useCashList = res.data.value;
                });
            },
            getStoreList(name){
                 getWxStoreSearch({name:name}).then((res) => {
                    console.log(res);
                    this.storeList = res.data.value
                    if (this.proId) {
                        this.initProDataDetail();
                    } else {
                        getProductsList4Erp().then((res) => {
                            this.erpProductList = res.data.value;
                        });
                    }
                });
            },
            addProduct(form){
                if (form.proName == null || form.proName == "") {
                    this.$notify({
                        title: '提示',
                        message: '商品名称为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.proNameSx == null || form.proNameSx == "") {
                    this.$notify({
                        title: '提示',
                        message: '商品名称缩写为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.proCode == null || form.proCode == "") {
                    this.$notify({
                        title: '提示',
                        message: '商品编号为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.barCode == null || form.barCode == "") {
                    this.$notify({
                        title: '提示',
                        message: '条形码为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.proTitle == null || form.proTitle == "") {
                    this.$notify({
                        title: '提示',
                        message: '商品标题为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.proSummary == null || form.proSummary == "") {
                    this.$notify({
                        title: '提示',
                        message: '商品名称摘为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.proTypeId == null || form.proTypeId == "") {
                    this.$notify({
                        title: '提示',
                        message: '产品类型为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.soldType == null || form.soldType == "") {
                    this.$notify({
                        title: '提示',
                        message: '销售类型为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.transportType == null || form.transportType == "") {
                    this.$notify({
                        title: '提示',
                        message: '运输方式为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.productCategoryId == null || form.productCategoryId == "") {
                    this.$notify({
                        title: '提示',
                        message: '产品类目为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.selfMadeType == null || form.selfMadeType == "") {
                    this.$notify({
                        title: '提示',
                        message: '是否自营为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.limitBuyCount == null || form.limitBuyCount == "") {
                    this.$notify({
                        title: '提示',
                        message: '单次最大购买量为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.limitBuyCountDaily == null || form.limitBuyCountDaily == "") {
                    this.$notify({
                        title: '提示',
                        message: '每日最大购买量为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.proPrice == null || form.proPrice == "") {
                    this.$notify({
                        title: '提示',
                        message: '建议价格为必填项',
                        type: 'danger'
                    });
                    return false
                }
                if (form.proPrice1 == null || form.proPrice1 == "") {
                    this.$notify({
                        title: '提示',
                        message: '单品原价为必填项',
                        type: 'danger'
                    });
                    return false
                }
//            if(form.thirdCatId == null || form.thirdCatId == ""){
//                this.$message({
//                    message:"小商店类目为必填项",
//                    type:'error'
//                });
//                return false
//            }
                if (form.proState == null || form.proState == "") {
                    this.$message({
                        message: "是否上架为必填项",
                        type: 'error'
                    });
                    return false
                }

                if (form.listTemplateFile != null && form.listTemplateFile != "" && form.listTemplateFile.indexOf('?') > 0) {
                    form.listTemplateFile = form.listTemplateFile.substring(0, form.listTemplateFile.indexOf('?'))
                }
                if (Array.isArray(form.storeCodes)) {
                    form.storeCodes = form.storeCodes.join(',');
                }
                addProduct(form).then((res) => {
                    if (res.data.status == 200) {

                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        if (this.proId == 0) {
                            this.proId = res.data.value
                            this.$router.replace({
                                path: '/productlist/detail/:id',
                                name: 'ProductDetail',
                                params: {id: res.data.value},
                                query: {proId: res.data.value, picType: '', picFrom: 'noReturn'}
                            })
                        }
                        this.tabSel = 'tab1'
                    } else {
                        // 如果res.data.message的内容包含"奶卡赠品"的字样，弹出失败窗口，并新建标签页打开几个页面
                        // 此时res.data.value返回的是一个字符串数组
                        // 获取此时页面的域名，然后拼接上"/#/free/detail/"，然后拼接上res.data.value的每个的值，组成若干个链接
                        // 在新建标签页里打开这些链接
                        // 如果res.data.message的内容不包含"奶卡赠品"，再执行下面这段代码
                        if (res.data.message && res.data.message.includes('奶卡赠品')) {
                            // 弹出失败窗口，点击确定后跳转
                            this.$alert(res.data.message, '点击确定后跳转到赠品', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            }).then(() => {
                                // 获取当前页面的域名
                                let origin = window.location.origin;
                                // 兼容 hash 路由
                                let basePath = origin + '/#';
                                // 遍历 value 数组，打开新标签页
                                res.data.value.forEach(val => {
                                    let url = basePath + '/free/detail/' + val;
                                    window.open(url, '_blank');
                                });
                            });
                            // 直接 return，不再执行后续代码
                            return;
                        }
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            gen(){
                this.proDetail.barCode = new Date().getTime() + '';
            },
            getBrandList(){
                //查询模板列表
                get_brand_list(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.brandList = res.data.value;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getCategoryList(){
                //查询模板列表
                getSkuCatList(this.formInline).then((res) => {
                    console.log(res);
                    let data = res.data.value
                    this.categoryList = data.firstCat.map(item => {
                        item.children = []
                        item.children = data.secondtCat.filter(item1 => {
                            item1.children = []
                            item1.children = data.thirdtCat.filter(item2 => {
                                return item2.parentId == item1.id
                            })
                            return item1.parentId == item.id
                        })
                        return item
                    })
                });
            },
            handleChange(e){
                console.log(e)
                this.proDetail.thirdCatId = e.length > 0 ? e[2] : ''
            },
            selectTransportType(transportTypes){
                this.proDetail.selfMadeType = transportTypes == 3 ? 1 : transportTypes
            },
            selectProductChanged(cguid){
                console.log('cguid=' + cguid);
                let arr = this.erpProductList.filter(function (item) {
                    return item.cguid == cguid;
                })
                console.log('arr=' + arr);
                if (arr.length > 0) {
                    let product = arr[0];
                    console.log('product=' + product);
                    this.proDetail.proName = product.cname
                    this.proDetail.proCode = product.ccode
                    this.proDetail.barCode = product.cbarcode
                    //this.proDetail.barCode=product.cbarcode
                    this.proDetail.proSpec = product.cproperty
                    this.proDetail.proDw = product.cunitname
                    this.proDetail.period = product.iexpirydays
                    if (product.icoldchain == 1) {
                        this.proDetail.transportTypes = 1
                    }
                    this.proDetail.proPrice = product.isaleprice
                    this.proDetail.proState = 1;
                    console.log('proDetail=' + this.proDetail);
                }
            },
            handleClick(e){
                console.log(e)

            },
            returnHistory(){
                window.history.go(-1)
            },
            handleStoreCodesChange(value) {
                console.log('Selected store codes:', value);
                this.proDetail.storeCodes = Array.isArray(value) ? value : [value];
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .productdetail-container {
        padding: 10px 20px;
        .header-return {
            margin-bottom: 20px;
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 10px;
        }
        .header-btn {
            float: right;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/editDetail/productdetail.vue